import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";
import { BUSINESS, NAV_LINKS, SERVICE_AREAS } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-brand-obsidian text-brand-bone mt-20">
      <div className="container-page py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <img src="/logo.png" alt="ME Builders" className="h-20 w-auto" />
          <p className="mt-5 text-sm text-brand-bone/70 leading-relaxed max-w-xs">
            Professional construction, plumbing, HVAC, drywall and remodeling — built clean, built to last. Serving {BUSINESS.region}.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href={BUSINESS.phoneHref} className="flex items-center gap-3 hover:text-white" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-brand-olive" />
              <span>{BUSINESS.phone}<span className="text-brand-bone/50 ml-2">· {BUSINESS.phoneLabel}</span></span>
            </a>
            <a href={BUSINESS.phoneAltHref} className="flex items-center gap-3 hover:text-white" data-testid="footer-phone-alt">
              <Phone className="w-4 h-4 text-brand-olive" />
              <span>{BUSINESS.phoneAlt}<span className="text-brand-bone/50 ml-2">· {BUSINESS.phoneAltLabel}</span></span>
            </a>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 hover:text-white" data-testid="footer-email">
              <Mail className="w-4 h-4 text-brand-olive" />{BUSINESS.email}
            </a>
            <div className="flex items-center gap-3 text-brand-bone/70">
              <Clock className="w-4 h-4 text-brand-olive" />{BUSINESS.hours}
            </div>
            <div className="flex items-center gap-3 text-brand-bone/70">
              <MapPin className="w-4 h-4 text-brand-olive" />{BUSINESS.region}
            </div>
          </div>

          <a
            href={BUSINESS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="mt-6 inline-flex items-center gap-3 px-4 py-2.5 rounded-sm bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm"
          >
            <Instagram className="w-4 h-4 text-brand-olive" />
            <span className="text-brand-bone font-semibold">Follow on Instagram</span>
            <span className="text-brand-bone/60">{BUSINESS.instagramHandle}</span>
          </a>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-brand-olive">Navigation</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-white text-brand-bone/80" data-testid={`footer-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-brand-olive">Service Areas</h4>
          <ul className="mt-5 space-y-2 text-sm">
            {SERVICE_AREAS.slice(0, 8).map((a) => (
              <li key={a.slug}>
                <Link to={`/areas/${a.slug}`} className="hover:text-white text-brand-bone/80">
                  {a.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-brand-olive">Trust</h4>
          <ul className="mt-5 space-y-2 text-sm text-brand-bone/80">
            <li>Licensed & Insured</li>
            <li>Certified by Google</li>
            <li>Certified by Yelp</li>
            <li>Certified by Angie's List</li>
            <li>Free Estimates</li>
            <li>Clean Workmanship</li>
            <li>Honest Pricing</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-brand-bone/60">
          <span>© {year} {BUSINESS.name}. All rights reserved.</span>
          <span>{BUSINESS.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
